<template>
  <pt-bill-lot-operate class="pt-bill-lot-operate__withData"></pt-bill-lot-operate>
</template>

<script>
import PtBillLotOperate from './index'
export default {
  name: 'pt-bill-lot-operate__withData',
  components: {
    'pt-bill-lot-operate': PtBillLotOperate
  }
}
</script>
